import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../../app/tamas-aluno.service';

@Component({
  selector: 'app-pesquisar-pre',
  templateUrl: './pesquisar-pre.component.html',
  styleUrls: ['./pesquisar-pre.component.css']
})
export class PesquisarPreComponent implements OnInit {
  hideLoginLoad: boolean = true;
  constructor(public router: Router, private _location: Location, public tmaService: TamasAlunoService) { }


  ngOnInit() {
    this.tmaService.gBackBusca = false;
  }

}
